export default __webpack_public_path__ + "3ab58352bf9d8768c1fa5d65528b9dbd.png";